import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_dashboard_RowClass} from '../../../dbschema/bl_wf_issue_dashboard.model';

export class WfIssueDashboardContainerModel extends BaseContainerModel {
  bl_wf_issue_dashboard: bl_wf_issue_dashboard_RowClass = new bl_wf_issue_dashboard_RowClass();
}
